import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type VendorState = readonly string[];

export const VENDOR = (
  Details: React.ComponentType<ConditionTypeDetailsProps<VendorState>>,
): ConditionType<VendorState, ModelCondition.Vendor> => ({
  name: "Vendors",
  description(state) {
    return `Vendors: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<VendorState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: ModelCondition.Vendor) {
    return model.vendors;
  },
  toModel(state) {
    return { type: ModelCondition.VENDOR, vendors: state };
  },
  valid() {
    return true;
  },
});
